// extracted by mini-css-extract-plugin
export var headerCell = "_17-1";
export var loadingSpinnerContainer = "_17-4";
export var rowWrapper = "_17-3";
export var standaloneTable = "_17-5";
export var table = "_17-0";
export var white = "_17-2";